/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cacheMessages, setMessages } from "../../Redux/reducers/messagesSlice";
import { useCallbackRef } from "../../Utils/useCallbackRef";
import ChatConversationPane from "./ChatConversationPane";
import ChatMessagingBar from "./ChatMessagingBar";
import ChatNavigationBar from "./ChatNavigationBar";
import NoConversation from "./NoConversation";
import { fetchChatCustomers } from "./fetchingData/fetchCustomers";
import { fetchChatSellers } from "./fetchingData/fetchSellers";

export default function ConversationWrapper({ activeTab }) {
  const [sellerConversation, setSellerConversation] = useState([]);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [customerConversation, setCustomerConversation] = useState([]);
  const currConversationId = useSelector((state) => state.conversationId.id);
  const user = useSelector((state) => state.user.user);
  const currRole = useSelector((state) => state.chatRole.role);
  const showPane = useSelector(
    (state) => state.responsiveHandle.showConversation
  );
  const dispatch = useDispatch()

  const cachedMessages = useSelector((state) => state.messages.cachedMessages);
  const cachedMessagesRef = useCallbackRef(cachedMessages)

  // setting the conversation data according to the role of the user.............

  const currentConversation = useMemo(() => {
    return currRole === "customer" ? sellerConversation : customerConversation;
  }, [currRole, sellerConversation, customerConversation]);

  const currentConversationData = currentConversation?.data;

  // setting names and avatar to show in the conversation pane according to the role of the user.............

  // const avatar =
  //   currRole === "customer"
  //     ? currentConversationData?.[0]?.seller?.avatar
  //     : currentConversationData?.[0]?.customer?.avatar;
  // const name =
  //   currRole === "customer"
  //     ? currentConversationData?.[0]?.seller?.name
  //     : currentConversationData?.[0]?.customer?.name;
  // const status = currRole === "customer"
  //   ? currentConversationData?.[0]?.seller?.status
  //   : currentConversationData?.[0]?.customer?.status;

  const { name, avatar, status } = useSelector(state => state.messages.currentChat)


  // fetching chats of the sellers and customers.............
  useEffect(() => {
    const controller = new AbortController();
    const fetchChat = async () => {
      if (user !== null) {
        if (currRole === "customer") {
          if (currConversationId) {
            const controller = new AbortController();
            const signal = controller.signal;
            console.log(cachedMessagesRef.current)
            if (currConversationId in cachedMessagesRef.current.sellers) {
              const chatData = cachedMessagesRef?.current?.sellers?.[currConversationId]
              dispatch(setMessages(chatData.data));
              setSellerConversation({ ...chatData });
              return
            }
            setIsChatLoading(true);
            const sellersChat = await fetchChatSellers({
              id: currConversationId,
              page: 1,
              signal,
            });
            setSellerConversation({ ...sellersChat });
            if (sellersChat.data && sellersChat.data.length > 0) {
              dispatch(setMessages(sellersChat?.data));
              dispatch(cacheMessages({ conversationId: currConversationId, chatData: sellersChat, isSeller: true }))
            }
            setIsChatLoading(false);
          } else return;
        }
        if (currRole === "seller") {
          if (currConversationId) {
            const controller = new AbortController();
            const signal = controller.signal;
            setIsChatLoading(true);
            if (currConversationId in cachedMessagesRef.current.customers) {
              const chatData = cachedMessagesRef?.current?.customers?.[currConversationId]
              dispatch(setMessages(chatData?.data));
              setCustomerConversation({ ...chatData });
              return
            }
            const customersChat = await fetchChatCustomers({
              id: currConversationId,
              page: 1,
              signal,
            });
            setCustomerConversation({ ...customersChat });
            if (customersChat.data && customersChat.data.length > 0) {
              dispatch(setMessages(customersChat?.data));
              dispatch(cacheMessages({ conversationId: currConversationId, chatData: customersChat, isSeller: false }))
            }
            setIsChatLoading(false);
          } else return;
        }
      }
    };
    fetchChat();
    return () => {
      controller.abort();
    };
  }, [currConversationId, currRole, user]);

  return (
    <div
      className={` ${showPane ? "showElement" : "hideElement"
        } conversation-wrapper position-relative`}
    >
      <img
        alt="chat-bg"
        // src="https://img.freepik.com/free-vector/mandala-patterns-isolated-background_1308-69554.jpg"
        src={window.location.origin + '/assets/images/chat-bg.png'}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          translate: "-50% -50%",
          height: 300,
          width: 300,
          zIndex: -1,
          opacity: 0.15

        }}
      />
      {currConversationId === 0 ? (
        <NoConversation />
      ) : (
        <>
          <ChatNavigationBar
            avatar={
              avatar
                ? avatar
                : name &&
                "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
                name
            }
            name={name ?? "No name"}
            number={currentConversationData?.[0]?.calling_number}
          />
          <ChatConversationPane
            isLoadig={isChatLoading}
            conversationData={currentConversation}
          />

          {status === "active" ?
            <ChatMessagingBar
              seller={currentConversationData?.[0]?.seller?.id}
              customer={currentConversationData?.[0]?.customer?.id}
              activeTab={activeTab}
            /> :
            <div className="text-center border-top pt-3">
              <p className="mb-0 small text-muted">You can't message this account.</p>
            </div>
          }
        </>
      )}
    </div>
  );
}
